// extracted by mini-css-extract-plugin
export default {"pointer":"Tip_pointer__Q7Gbu","popup":"Tip_popup__2V88m","selectIdPopup":"Tip_selectIdPopup__kOHz9"};